import { combineReducers } from 'redux';

import patients from './patients/reducer';
import visits from './visits/reducer';

export default combineReducers({
  patients,
  visits,
});
